import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading,
  withViewTransitions,
} from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbDateParserFormatter, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

import { routes } from './app.routes';
import { PermissionService } from './core/services/permission.service';
import { NgbDateMMDDYYYYParserFormatter } from './core/utils/ngb-date-mmddyyyy.formatter';

/**
 * Token attachment, request encryption and 401 handling now live in `ApiService`
 * (matching the reference app's structure), so no HTTP interceptor is registered.
 * Runtime settings come from `src/environments/environment.ts` (compiled in).
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withViewTransitions(),
    ),
    provideHttpClient(),
    provideAnimations(),
    // Decrypt the cached permissions before the first route resolves, so a hard
    // refresh doesn't gate the sidebar and guards against an empty set.
    provideAppInitializer(() => inject(PermissionService).ensureLoaded()),
    {
      // Drops the default 'focus' trigger app-wide. A modal restores focus to the
      // button that opened it, which would otherwise re-open that button's tooltip
      // with no pointer over it to dismiss it. Icon-only buttons need an aria-label
      // to stay accessible, since the tooltip no longer shows on keyboard focus.
      provide: NgbTooltipConfig,
      useFactory: () => Object.assign(new NgbTooltipConfig(), { triggers: 'hover' }),
    },
    // App-wide: every ngbDatepicker input displays/parses as MM-DD-YYYY.
    { provide: NgbDateParserFormatter, useClass: NgbDateMMDDYYYYParserFormatter },
  ],
};
